module.exports = __webpack_public_path__ + "static/logoPL-EN-51cb3eb078225cdc417ec620fc2e7f4e.svg";